<template>
    <div>
        <v-container fluid pa-0>
            <v-card elevation="0">
                <v-container fluid grid-list-xl class="toolbar-container">
                    <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                        <v-toolbar color="grey lighten-3" elevation="1">
                            <bc-btn-back></bc-btn-back>
                            <v-menu :nudge-width="50" offset-y>
                                <v-toolbar-title slot="activator" class="d-inline-flex">
                                    <div>
                                        <span style="position: relative; bottom: -6px">{{ $t(`lang.${current_view}`) }}</span>
                                        <br />
                                        <span style="font-size: 14px; position: relative; top: -6px; font-weight: normal">{{
                                            $route.query.date_received || current_day
                                        }}</span>
                                    </div>
                                    <v-icon dark class="unselectable">arrow_drop_down</v-icon>
                                </v-toolbar-title>

                                <v-list>
                                    <v-list-tile v-for="(item, index) in toolbar_items" :key="index" @click="setView(item.value)">
                                        <v-list-tile-title>{{ item.text }}</v-list-tile-title>
                                    </v-list-tile>
                                </v-list>
                            </v-menu>
                            <!-- <v-toolbar-title class="ml-0"><span style="position: relative;bottom: -6px;">{{$t($route.meta.title)}}</span><br/><span style="font-size: 14px;position: relative;top: -6px; font-weight: normal">{{ $route.query.date_received || current_day }}</span></v-toolbar-title> -->
                            <v-spacer></v-spacer>
                            <template v-if="current_view == 'receiving'">
                                <bc-modal-print
                                    v-show="selected_receiving.length > 0"
                                    ref="print"
                                    @invoke-method="dev_mode ? showPrinters() : printLabels()"
                                    @close-method="(file_name = null), $refs.print.close()"
                                    :file-name="file_name"
                                    :printItems="selected_receiving"
                                ></bc-modal-print>
                                <bc-scan-barcode
                                    ref="scan_barcode"
                                    scan-object="part_number"
                                    :tooltip="$t('lang.scan_code')"
                                    :header-text="show_barcode_options ? 'Select Correct Part' : 'Part Lookup'"
                                    @scanned="parseBarcode($event)"
                                    scan-label="r"
                                    :show-options-slot="show_barcode_options"
                                    :global="true"
                                >
                                    <vue-perfect-scrollbar
                                        v-if="show_barcode_options"
                                        class="scroll-area"
                                        :style="$bp.xs ? null : 'max-height: calc(100vh - 150px)'"
                                    >
                                        <v-list two-line class="dropdown-list">
                                            <template v-for="(barcode, index) in barcode_options">
                                                <div :key="index" v-if="index < 5">
                                                    <v-divider v-if="index > 0" class="ma-0 grey lighten-1"></v-divider>
                                                    <v-list-tile
                                                        v-ripple
                                                        class="clickable text-xs-center headline"
                                                        :class="{ 'list-hover': !$bp.smallScreen }"
                                                        @click="setInfoFromBarcode(barcode)"
                                                    >
                                                        <v-list-tile-content>
                                                            <v-list-tile-title v-html="barcode.name" class="fw-bold"></v-list-tile-title>
                                                            <v-list-tile-sub-title v-html="barcode.company"></v-list-tile-sub-title>
                                                        </v-list-tile-content>
                                                    </v-list-tile>
                                                </div>
                                            </template>
                                        </v-list>
                                    </vue-perfect-scrollbar>
                                </bc-scan-barcode>
                                <bc-btn-add @invoke-method="invokeMethod($event)" action="showReceiving" perm="receiving.create"></bc-btn-add>
                                <bc-tooltip>
                                    <template slot="activator">
                                        <v-btn
                                            v-if="(warehouse && warehouse.length > 0) || warehouse_dialog"
                                            icon
                                            @mouseup.left="getWarehouse(true)"
                                            class="hidden-sm-and-down"
                                        >
                                            <v-icon class="material-icons-outlined">warehouse</v-icon>
                                        </v-btn>
                                    </template>
                                    {{ $t("lang.warehouse") }}
                                </bc-tooltip>
                                <bc-btn-refresh @invoke-method="dbGetReceiving()"></bc-btn-refresh>
                            </template>
                            <bc-search-menu :params="axiosParams" @open="getArrayData()">
                                <v-list>
                                    <v-list-tile class="mb-3">
                                        <bc-search-input v-model="filter.search" :params="axiosParams"></bc-search-input>
                                    </v-list-tile>
                                    <v-list-tile class="mb-3">
                                        <bc-autocomplete
                                            v-model="filter.company_id"
                                            :label="$t('lang.company_id')"
                                            :items="customer_options"
                                            item-value="company_id"
                                            item-text="company"
                                            prepend-icon="business"
                                            single-line
                                            :hide-details="true"
                                            clearable
                                            @click:clear="filterClearInput()"
                                        ></bc-autocomplete>
                                    </v-list-tile>
                                    <!-- <v-list-tile class="mb-3">
                                        <bc-select
                                            v-model="filter.in_warehouse"
                                            :label="$t('lang.in_warehouse')"
                                            :items="warehouse_options"
                                            prepend-icon="inventory"
                                            single-line
                                            :hide-details="true"
                                        ></bc-select>
                                    </v-list-tile> -->
                                    <v-list-tile class="mb-3">
                                        <bc-date-picker
                                            v-model="filter.date_received"
                                            :label="$t('lang.date')"
                                            @update="filter.date_received = $event"
                                            :hide-details="true"
                                            prepend-icon="local_shipping"
                                            single-line
                                            class="w-100"
                                            :clearable="filter.date_received != default_filter.date_received"
                                            @click:clear="filterClearInput('date_received')"
                                        ></bc-date-picker>
                                    </v-list-tile>
                                    <v-list-tile class="mb-3">
                                        <bc-select
                                            v-model="filter.line_id"
                                            :label="$t('lang.production_line')"
                                            :items="[
                                                { value: 1, text: 'Batch' },
                                                { value: 2, text: 'Continuous' },
                                            ]"
                                            item-value="value"
                                            item-text="text"
                                            prepend-icon="precision_manufacturing"
                                            single-line
                                            :hide-details="true"
                                        ></bc-select>
                                    </v-list-tile>
                                </v-list>
                            </bc-search-menu>
                            <bc-btn-mobile-nav @invoke-method="invokeMethod($event)" :mobile-list="mobile_list"></bc-btn-mobile-nav>
                        </v-toolbar>
                    </v-layout>
                </v-container>

                <v-card-text :class="$bp.xsOnly ? 'pa-0' : null">
                    <v-data-table
                        v-if="current_view == 'summary'"
                        :headers="summary_headers"
                        :items="summary_receiving"
                        :no-data-text="$t('lang.no_results_matching')"
                        hide-actions
                        :must-sort="true"
                    >
                        <template slot="items" slot-scope="props">
                            <tr>
                                <td>{{ props.item.name }}</td>
                                <td>{{ props.item.dta_part_code }}</td>
                                <td>{{ props.item.company }}</td>
                                <td>{{ props.item.customer_part_number }}</td>
                                <td>{{ props.item.received_qty }}</td>
                                <td>{{ props.item.total_lots }}</td>
                            </tr>
                        </template>
                    </v-data-table>
                    <v-data-table
                        v-else
                        v-model="selected_receiving"
                        :headers="headers"
                        :items="receiving"
                        :no-data-text="$t('lang.no_results_matching')"
                        item-key="receiving_id"
                        hide-actions
                        select-all
                        :must-sort="true"
                    >
                        <template slot="items" slot-scope="props">
                            <tr>
                                <td>
                                    <v-checkbox
                                        @click.stop="props.selected = !props.selected"
                                        :input-value="props.selected"
                                        primary
                                        hide-details
                                        :class="props.item.printed == '0' ? 'green-checkbox' : ''"
                                        :off-icon="props.item.printed == '0' ? 'print' : 'check_box_outline_blank'"
                                        :color="props.selected && props.item.printed == '0' ? 'green' : ''"
                                    ></v-checkbox>
                                </td>
                                <td class="clickable" @mouseup.left="showReceiving(props.item)">{{ props.item.receiving_control_id }}</td>
                                <td class="clickable" @mouseup.left="showReceiving(props.item)">
                                    <strong>{{ props.item.name }}</strong>
                                    <br />
                                    <small>{{ props.item.company }}</small>
                                </td>
                                <td class="clickable" @mouseup.left="showReceiving(props.item)">{{ props.item.dta_part_code }}</td>
                                <td class="clickable" @mouseup.left="showReceiving(props.item)">{{ props.item.production_line }}</td>
                                <td class="clickable" @mouseup.left="showReceiving(props.item)">{{ props.item.customer_part_number }}</td>
                                <td class="clickable" @mouseup.left="showReceiving(props.item)">{{ props.item.received_qty }}</td>
                                <td class="clickable" @mouseup.left="showReceiving(props.item)">{{ props.item.date_received }}</td>
                                <td class="clickable" @mouseup.left="showReceiving(props.item)">
                                    <v-layout justify-center>
                                        <v-icon v-if="+props.item.warehouse_qty > 0">warehouse</v-icon>
                                    </v-layout>
                                </td>
                                <td>
                                    <bc-btn-nonconformance
                                        entity_object="receiving"
                                        :entity_id="props.item.receiving_id"
                                        :item="props.item"
                                        permanent
                                    ></bc-btn-nonconformance>
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                    <bc-pagination :page="page" :params="axiosParams" name="receiving"></bc-pagination>
                </v-card-text>
            </v-card>

            <bc-dialog :value="receiving_dialog" max-width="1000">
                <v-card>
                    <v-card-title>
                        <span class="headline">{{
                            currObjField("receiving_id")
                                ? currObjField("has_batches") == "0"
                                    ? $t("lang.edit_delivery")
                                    : $t("lang.view_delivery")
                                : $t("lang.receive_parts")
                        }}</span>
                        <v-spacer></v-spacer>
                        <bc-btn-dialog-close
                            @invoke-method="invokeMethod($event)"
                            action="closeReceivingDialog"
                            :dialog-status="receiving_dialog"
                        ></bc-btn-dialog-close>
                    </v-card-title>
                    <v-card-text>
                        <v-form ref="receiving">
                            <v-container
                                grid-list-form
                                style="max-width: 100%"
                                :class="{ 'prevent-click': currObjField('receiving_id') && currObjField('has_batches') != '0' }"
                            >
                                <v-layout row wrap>
                                    <v-flex xs12 sm4 align-self-start>
                                        <v-layout row wrap>
                                            <v-flex xs12 inner-flex d-inline-flex>
                                                <bc-autocomplete
                                                    :focus="
                                                        receiving_dialog &&
                                                        (!currObjField('receiving_id') || (currObjField('receiving_id') && currObjField('has_batches') == '0'))
                                                    "
                                                    v-model="receive.part_id"
                                                    :label="`${$t('lang.part_number')} *`"
                                                    class="w-100"
                                                    :items="parts || []"
                                                    item-value="part_id"
                                                    item-text="customer_part_number"
                                                    :rules="ifValid('receiving.part_id')"
                                                    @change="getPartInfo($event)"
                                                    :tabindex="currObjField('receiving_id') && currObjField('has_batches') != '0' ? '-1' : ''"
                                                ></bc-autocomplete>
                                            </v-flex>
                                            <v-flex xs12 inner-flex>
                                                <v-text-field
                                                    v-model="receive.received_qty"
                                                    :label="`${$t('lang.qty')} *`"
                                                    :counter="showCounter(receive.received_qty, 'receiving.received_qty')"
                                                    :rules="ifValid('receiving.received_qty')"
                                                    :tabindex="currObjField('receiving_id') && currObjField('has_batches') != '0' ? '-1' : ''"
                                                    type="number"
                                                ></v-text-field>
                                            </v-flex>
                                            <v-flex xs12 inner-flex>
                                                <v-text-field
                                                    v-model="receive.lot_number"
                                                    :label="`${$t('lang.lot_number')}`"
                                                    :counter="showCounter(receive.lot_number, 'receiving.lot_number')"
                                                    :rules="ifValid('receiving.lot_number')"
                                                    :tabindex="currObjField('receiving_id') && currObjField('has_batches') != '0' ? '-1' : ''"
                                                ></v-text-field>
                                            </v-flex>
                                            <v-flex xs12 inner-flex>
                                                <v-text-field
                                                    v-model="receive.po_number"
                                                    :label="`${$t('lang.po_number')}`"
                                                    :counter="showCounter(receive.po_number, 'receiving.po_number')"
                                                    :rules="ifValid('receiving.po_number')"
                                                    :tabindex="currObjField('receiving_id') && currObjField('has_batches') != '0' ? '-1' : ''"
                                                ></v-text-field>
                                            </v-flex>
                                            <v-flex xs12 inner-flex>
                                                <bc-date-picker
                                                    v-model="receive.date_received"
                                                    :label="$t('lang.date_received')"
                                                    :rules="ifValid('receiving.date_received')"
                                                    :disabled="currObjField('receiving_id') && currObjField('has_batches') != '0'"
                                                    :input-class="'prevent-click'"
                                                    @update="receive.date_received = $event"
                                                    :tabindex="currObjField('receiving_id') && currObjField('has_batches') != '0' ? '-1' : ''"
                                                ></bc-date-picker>
                                            </v-flex>
                                        </v-layout>
                                    </v-flex>
                                    <v-flex xs12 sm3 align-self-start :key="update_info">
                                        <v-layout row wrap>
                                            <v-flex xs12 pb-2>
                                                <span class="fs-18">{{ $t("lang.company") }}</span>
                                                <h2>{{ currPartInfo("company") ? currPartInfo("company") : "---" }}</h2>
                                            </v-flex>
                                            <v-flex xs12 pb-2>
                                                <span class="fs-18">{{ $t("lang.part_name") }}</span>
                                                <h2>{{ currPartInfo("name") ? currPartInfo("name") : "---" }}</h2>
                                            </v-flex>
                                            <v-flex xs12 pb-2>
                                                <span class="fs-18">{{ $t("lang.dta_part_code") }}</span>
                                                <h2>{{ currPartInfo("dta_part_code") ? currPartInfo("dta_part_code") : "---" }}</h2>
                                            </v-flex>
                                        </v-layout>
                                    </v-flex>
                                    <v-flex xs12 sm5>
                                        <v-img
                                            v-if="currPartInfo('photo')"
                                            :src="currPartInfo('photo')"
                                            height="200px"
                                            width="200px"
                                            class="rounded-circle ma-auto"
                                            :key="`photo_${update_info}`"
                                        ></v-img>
                                        <span v-else class="ma-auto fs-32 grey--text">Select part for preview</span>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn
                            v-if="currObjField('receiving_id') && currObjField('has_batches') == '0' && hasPerm('receiving.delete')"
                            color="error"
                            @mouseup.left="$refs.delete_receiving.openDialog()"
                            >{{ $t("lang.delete") }}</v-btn
                        >
                        <v-switch
                            v-else-if="!currObjField('receiving_id')"
                            v-model="action_onsave"
                            :label="action_onsave ? 'After Save: Add Another' : 'After Save: Close'"
                            ripple
                            class="my-auto"
                        ></v-switch>
                        <v-spacer></v-spacer>
                        <v-btn flat @mouseup.left="closeReceivingDialog()">{{ $t("lang.cancel") }}</v-btn>
                        <v-btn
                            v-if="!currObjField('receiving_id') || currObjField('has_batches') == '0'"
                            color="success"
                            @mouseup.left="modifyReceiving(currObjField('receiving_id') ? 'patch' : 'post', currObjField('receiving_id'))"
                            >{{ $t("lang.save") }}</v-btn
                        >
                        <v-btn
                            v-if="!currObjField('receiving_id') || currObjField('has_batches') == '0'"
                            color="success"
                            @mouseup.left="modifyReceiving(currObjField('receiving_id') ? 'patch' : 'post', currObjField('receiving_id'), true)"
                            >{{ $t("lang.save_and_print") }}</v-btn
                        >
                        <v-btn
                            v-else-if="currObjField('has_batches') == '1'"
                            color="primary"
                            @mouseup.left="dev_mode ? showPrinter(currObjField('receiving_id')) : printLabel(currObjField('receiving_id'))"
                            >{{ $t("lang.print") }}</v-btn
                        >
                    </v-card-actions>
                </v-card>
            </bc-dialog>

            <bc-modal-print ref="save_and_print" :no-button="true"></bc-modal-print>

            <bc-dialog :value="warehouse_dialog" :max-width="1100">
                <v-card>
                    <v-card-title>
                        <span class="headline">{{ $t("lang.warehouse") }}</span>
                        <v-spacer></v-spacer>
                        <bc-btn-dialog-close
                            @invoke-method="invokeMethod($event)"
                            action="closeWarehouseDialog"
                            :dialog-status="warehouse_dialog"
                        ></bc-btn-dialog-close>
                    </v-card-title>
                    <v-card-text class="pa-0">
                        <v-data-table
                            :headers="warehouse_headers"
                            :items="warehouse"
                            :no-data-text="$t('lang.no_results_matching')"
                            hide-actions
                            :must-sort="true"
                            :pagination.sync="warehouse_default_sort"
                        >
                            <template slot="items" slot-scope="props">
                                <tr class="clickable" @mouseup.left="goToPart(props.item)">
                                    <td class="text-center">
                                        <v-icon v-if="props.item.days_aged_icon" :color="props.item.days_aged_class">{{ props.item.days_aged_icon }}</v-icon>
                                    </td>
                                    <td class="text-center">{{ props.item.days_aged }}</td>
                                    <td>{{ props.item.company }}</td>
                                    <td :class="props.item.has_part_process_error == '1' || !props.item.furnace_options ? 'red--text' : ''">
                                        {{ props.item.customer_part_number }}
                                    </td>
                                    <td>{{ props.item.name }}</td>
                                    <td class="text-center">{{ props.item.warehouse_qty }}</td>
                                </tr>
                            </template>
                        </v-data-table>
                    </v-card-text>
                </v-card>
            </bc-dialog>
            <delete-confirmation-dialog
                ref="delete_receiving"
                :heading="$t('lang.delete_delivery')"
                :message="$t('lang.confirm_delete_message')"
                @onConfirm="modifyReceiving('delete', currObjField('receiving_id'))"
            ></delete-confirmation-dialog>
        </v-container>
    </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { store } from "Store/store";

export default {
    data() {
        return {
            current_view: "receiving",
            warehouse_dialog: false,
            toolbar_items: [
                { text: this.$t("lang.receiving"), value: "receiving" },
                { text: this.$t("lang.summary"), value: "summary" },
            ],
            headers: [
                { text: this.$t("lang.control_id"), value: "receiving_control_id" },
                { text: this.$t("lang.part_name"), value: "name" },
                { text: this.$t("lang.part_code"), value: "dta_part_code" },
                { text: this.$t("lang.production_line"), value: "company" },
                { text: this.$t("lang.part_number"), value: "customer_part_number" },
                { text: this.$t("lang.received_qty"), value: "received_qty" },
                { text: this.$t("lang.date_received"), sortable: false },
                { text: "", sortable: false },
                { text: "", sortable: false },
            ],
            summary_headers: [
                { text: this.$t("lang.part_name"), value: "name" },
                { text: this.$t("lang.part_code"), value: "dta_part_code" },
                { text: this.$t("lang.company"), value: "company" },
                { text: this.$t("lang.part_number"), value: "customer_part_number" },
                { text: this.$t("lang.received_qty"), value: "received_qty" },
                { text: this.$t("lang.total_lots"), value: "total_lots" },
            ],
            warehouse_headers: [
                { text: "", sortable: false, width: "5%" },
                { text: this.$t("lang.aged"), value: "days_aged", width: "10%", align: "center" },
                { text: this.$t("lang.customer"), value: "company", width: "25%" },
                { text: this.$t("lang.part_number_short"), value: "customer_part_number", width: "20%" },
                { text: this.$t("lang.part_name"), value: "name", width: "25%" },
                { text: this.$t("lang.warehouse_qty"), value: "warehouse_qty", width: "15%", align: "center" },
            ],
            warehouse_default_sort: {
                descending: true,
                sortBy: "days_aged",
                rowsPerPage: -1,
            },
            selected_receiving: [],
            customers: null,
            receive: {
                company_id: "",
                part_id: "",
                received_qty: "",
                lot_number: "",
                po_number: "",
                date_received: "",
            },
            current_obj: null,
            part_info: null,
            file_name: null,
            show_barcode_options: false,
            barcode_options: [],
            update_info: 0,
            from_scan: false,
            action_onsave: false,
            filter: {
                search: "",
                company_id: "",
                // in_warehouse: "",
                date_received: this.current_day,
                page_size: 0,
                page_num: 0,
                line_id: "",
            },
            receiving_dialog: false,
            warehouse_options: [
                { text: this.$t("lang.all"), value: "" },
                { text: this.$t("lang.in_warehouse"), value: "1" },
                { text: this.$t("lang.not_in_warehouse"), value: "0" },
            ],
            mobile_list: [
                { title: this.$t("lang.warehouse"), action: "getWarehouse", params: [true] },
                { title: this.$t("lang.add_new"), action: "showReceiving" },
                { title: this.$t("lang.refresh"), action: "dbGetReceiving" },
            ],
            dbGetReceiving: _.debounce(this.getReceiving, 1500, { maxWait: 1500, leading: true, trailing: false }),
        };
    },
    beforeRouteEnter(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        const receiving = new Promise((resolve, reject) => {
            store
                .dispatch("fetchWorkOrder", {
                    url: "receiving",
                    method: "get",
                    stateProperty: "receiving",
                    commit: true,
                    body: parsedQuery,
                })
                .then((data) => {
                    typeof data !== "undefined" ? resolve(data.receiving) : reject(new Error("reject"));
                });
        });

        const parts = new Promise((resolve, reject) => {
            store
                .dispatch("fetchPart", {
                    url: "parts",
                    method: "get",
                    stateProperty: "parts",
                    commit: true,
                })
                .then((data) => {
                    typeof data !== "undefined" ? resolve(data.parts) : reject(new Error("reject"));
                });
        });

        store.dispatch("fetchWorkOrder", {
            url: "warehouse?line_id=2",
            method: "get",
            stateProperty: "warehouse",
            commit: true,
        });

        store.dispatch("fetchWorkOrder", {
            url: "receiving/summary",
            method: "get",
            stateProperty: "summary_receiving",
            dataProperty: "receiving",
            commit: true,
            body: parsedQuery,
        });

        Promise.all([receiving, parts])
            .then(([receiving, parts]) => {
                // console.log(receiving, parts)
                if (typeof receiving !== "undefined") {
                    next((vm) => {
                        vm.current_view = to.params && to.params.view ? to.params.view : "receiving";
                        vm.$store.commit("commitWorkOrder", { property: "receiving_filter.date_received", with: vm.current_day });
                        vm.setQuery(parsedQuery, vm.filter, vm.default_filter);
                        vm.finishLoader();
                    });
                } else {
                    next({ name: "dashboard", replace: true });
                }
            })
            .catch((error) => {
                store.commit("toggleLoginLoader", false);
                store.commit("finishLoader");
                next(false); //if any of them error, don't go to route, else set variables and proceed to route
            });
    },
    beforeRouteUpdate(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        const receiving = new Promise((resolve, reject) => {
            this.$store
                .dispatch("fetchWorkOrder", {
                    url: "receiving",
                    method: "get",
                    stateProperty: "receiving",
                    commit: true,
                    body: parsedQuery,
                })
                .then((data) => {
                    typeof data !== "undefined" ? resolve(data.receiving) : reject(new Error("reject"));
                });
        });

        const parts = new Promise((resolve, reject) => {
            this.$store
                .dispatch("fetchPart", {
                    url: "parts",
                    method: "get",
                    stateProperty: "parts",
                    commit: true,
                })
                .then((data) => {
                    typeof data !== "undefined" ? resolve(data.parts) : reject(new Error("reject"));
                });
        });

        store.dispatch("fetchWorkOrder", {
            url: "receiving/summary",
            method: "get",
            stateProperty: "summary_receiving",
            dataProperty: "receiving",
            commit: true,
            body: parsedQuery,
        });

        Promise.all([receiving, parts])
            .then(([receiving, parts]) => {
                if (typeof receiving !== "undefined") {
                    this.current_view = to.params && to.params.view ? to.params.view : "receiving";
                    this.setQuery(parsedQuery, this.filter, this.default_filter);
                    this.finishLoader();
                    next();
                } else {
                    next({ name: "dashboard", replace: true });
                }
            })
            .catch((error) => {
                this.$store.commit("finishLoader");
                next(false); //if any of them error, don't go to route, else set variables and proceed to route
            });
    },
    computed: {
        ...mapState({
            rules_receiving: (state) => state.validation.rules_receiving,
            default_filter: (state) => state.work_orders.receiving_filter,
            page: (state) => state.work_orders.page,
            receiving: (state) => state.work_orders.receiving,
            summary_receiving: (state) => state.work_orders.summary_receiving,
            parts: (state) => state.parts.parts,
            warehouse: (state) => state.work_orders.warehouse,
            customer_options: (state) => state.customers.customer_options,
        }),
        axiosParams() {
            return this.prepareParams(this.filter, this.default_filter);
        },
        // axiosParams() {
        //     let prep_filter = {};
        //     let new_date = ((!this.$route.query.date_received && this.filter.date_received != this.default_filter.date_received) || (!!this.$route.query.date_received && (this.default_filter.date_received != this.filter.date_received || this.$route.query.date_received != this.filter.date_received)));
        //     if((this.filter.search && this.filter.search != '') || this.filter.company_id || new_date) prep_filter = this.filter;
        //     return this.prepareParams(prep_filter, this.default_filter);
        // },
        currObjField() {
            return (field) => {
                return this.current_obj && field && this.current_obj[field] ? this.current_obj[field] : "";
            };
        },
        currPartInfo() {
            return (field) => {
                return this.part_info && field && this.part_info[field] ? this.part_info[field] : "";
            };
        },
    },
    methods: {
        ...mapActions(["fetchCustomers"]),
        getArrayData() {
            if (this.customers == null) this.getCustomers();
        },
        closeReceivingDialog() {
            this.from_scan = false;
            this.receiving_dialog = false;
            if (this.$refs.delete_receiving) this.$refs.delete_receiving.close();
            this.$store.commit("validationOff");
            this.$store.commit("toggleModalLoader", false);
            this.action_onsave = false;
            this.current_obj = null;
        },
        getReceiving(refresh = true, method = null) {
            if (refresh) this.startLoader();
            this.$store
                .dispatch("fetchWorkOrder", {
                    url: "receiving",
                    method: "get",
                    stateProperty: "receiving",
                    commit: true,
                    body: JSON.parse(JSON.stringify(this.$route.query)),
                })
                .then((data) => {
                    if (typeof data === "undefined") this.$router.push({ name: "dashboard" });
                })
                .finally(() => {
                    if (refresh || !this.action_onsave || method == "delete") {
                        this.receiving_dialog = false;
                    } else {
                        // if receiving multiple in a row
                        if (this.from_scan) {
                            this.$refs.scan_barcode.openBarcode();
                            this.receiving_dialog = false;
                            this.current_obj = null;
                        } else {
                            this.showReceiving();
                        }
                    }
                    this.$store.commit("toggleModalLoader", false);
                    this.$store.commit("validationOff");
                    if (this.$refs.delete_receiving) this.$refs.delete_receiving.close();
                    this.finishLoader(refresh);
                });
        },
        getCustomers() {
            this.fetchCustomers({ body: { options: 1 } });
        },
        modifyReceiving(method = null, id = null, print = false) {
            if (method) {
                this.$store.commit("validationOn");
                this.$nextTick(() => {
                    if (method == "delete" || this.validateForm("receiving")) {
                        this.$store.commit("toggleModalLoader", true);
                        this.$store
                            .dispatch("fetchWorkOrder", {
                                pk: "receiving_id",
                                id: id,
                                url: `receiving/${id ? id : ""}`,
                                method: method,
                                stateProperty: "receiving",
                                body: this.receive,
                            })
                            .then((data) => {
                                if (data && data.code == "200") {
                                    if (print) {
                                        if (this.dev_mode) {
                                            this.showPrinter(data.receiving.receiving_id);
                                        } else {
                                            this.$store
                                                .dispatch("fetchWorkOrder", {
                                                    url: `receiving/print_4x6_label`,
                                                    method: "get",
                                                    body: {
                                                        receiving_id: data.receiving.receiving_id,
                                                    },
                                                })
                                                .then((print_data) => {
                                                    if (typeof print_data != "undefined" && print_data.receiving) {
                                                        this.$refs.save_and_print.printReport(print_data.receiving.file_name);
                                                        this.$store.commit("mutateWorkOrder", {
                                                            property: "receiving",
                                                            method: "patch",
                                                            id: data.receiving.receiving_id,
                                                            pk: "receiving_id",
                                                            with: {
                                                                printed: "1",
                                                            },
                                                        });
                                                    } else {
                                                        this.createAlert();
                                                    }
                                                });
                                        }
                                    }
                                    this.getReceiving(false, method);
                                } else {
                                    this.$store.commit("toggleModalLoader", false);
                                }
                            });
                    }
                });
            }
        },
        showReceiving(item = null) {
            this.from_scan = false;
            this.current_obj = item;

            if (this.$refs.receiving) item ? this.$refs.receiving.resetValidation() : this.$refs.receiving.reset();

            this.$nextTick(() => {
                this.assignObj(this.receive, item, this.rules_receiving);
                if (!item) this.receive.date_received = this.current_day;
                this.part_info = item ? item : null;
                this.receiving_dialog = true;
            });
        },
        getParts() {
            this.startLoader();
            this.$store
                .dispatch("fetchPart", {
                    url: "parts",
                    method: "get",
                    stateProperty: "parts",
                    commit: true,
                })
                .then((data) => {
                    if (typeof data === "undefined") this.$router.push({ name: "dashboard" });
                })
                .finally(() => {
                    this.part_dialog = false;
                    this.$store.commit("toggleModalLoader", false);
                    this.$store.commit("validationOff");
                    this.finishLoader(true);
                });
        },
        getPartInfo(part, from_scan = false) {
            if (part) {
                this.$store.commit("toggleModalLoader", true);
                this.$store
                    .dispatch("fetchPart", {
                        url: `parts/${part}`,
                        method: "get",
                    })
                    .then((data) => {
                        if (typeof data !== "undefined") {
                            this.part_info = data.parts;
                            if (!from_scan) this.receive.po_number = data.parts.po_number || "";
                            this.receive.company_id = data.parts && data.parts.company_id ? data.parts.company_id : "";
                            this.receive.received_qty = data.parts && data.parts.receiving_qty ? data.parts.receiving_qty : "";
                            this.update_info++;
                            this.$store.commit("toggleModalLoader", false);
                            this.$store.commit("toggleGlobalSnackbar", false);
                        }
                    });
            }
        },
        setInfoFromBarcode(part) {
            this.part_info = part;
            this.receive.company_id = part.company_id ? part.company_id : "";
            this.receive.part_id = part.part_id ? part.part_id : "";
            // this.createAlert('success', 'part_found');
            setTimeout(() => {
                this.$refs.scan_barcode.closeBarcode();
                this.$store.commit("toggleModalLoader", false);
            }, 300);
            this.barcode_options = [];
            this.show_barcode_options = false;
            this.receiving_dialog = true;
        },
        submitBarcode(barcode_value) {
            if (!!barcode_value) {
                let barcode_body = {
                    barcode: barcode_value,
                };
                // console.log(barcode_value)
                // console.log(barcode_body)
                this.$store
                    .dispatch("fetchPart", {
                        url: `parts`,
                        method: "get",
                        body: barcode_body,
                    })
                    .then((data) => {
                        if (data && data.parts && data.parts.length > 0) {
                            // data.parts.push(data.parts[0]) // example code only
                            if (data.parts.length == 1) {
                                this.setInfoFromBarcode(data.parts[0]);
                            } else {
                                this.barcode_options = data.parts;
                                this.show_barcode_options = true;
                            }
                        } else {
                            this.$refs.scan_barcode.resetBarcode(true);
                        }
                    });
            } else {
                this.$refs.scan_barcode.resetBarcode(true);
            }
        },
        printLabel(id) {
            this.$store.commit("toggleModalLoader", true);
            this.$store
                .dispatch("fetchWorkOrder", {
                    url: `receiving/print_4x6_label`,
                    method: "get",
                    body: {
                        receiving_id: id,
                    },
                })
                .then((data) => {
                    if (typeof data != "undefined" && data.receiving) {
                        this.$refs.save_and_print.printReport(data.receiving.file_name);
                        this.$store.commit("mutateWorkOrder", {
                            property: "receiving",
                            method: "patch",
                            id: id,
                            pk: "receiving_id",
                            with: {
                                printed: "1",
                            },
                        });
                    } else {
                        this.createAlert();
                    }
                    this.$store.commit("toggleModalLoader", false);
                });
        },
        printLabels() {
            this.$store.commit("toggleGlobalSnackbar", true);

            this.$store
                .dispatch("fetchWorkOrder", {
                    url: `receiving/print_4x6_label`,
                    method: "get",
                    body: {
                        receiving_id: this.selected_receiving.map((r) => r.receiving_id),
                    },
                })
                .then((data) => {
                    if (typeof data != "undefined" && data.receiving) {
                        this.$refs.print.printReport(data.receiving.file_name);
                        this.selected_receiving.forEach((r) => {
                            this.$store.commit("mutateWorkOrder", {
                                property: "receiving",
                                method: "patch",
                                id: r.receiving_id,
                                pk: "receiving_id",
                                with: {
                                    printed: "1",
                                },
                            });
                        });
                    } else {
                        this.createAlert();
                    }
                    this.$store.commit("toggleGlobalSnackbar", false);
                });
        },
        showPrinter(id) {
            // this.startLoader();
            this.$refs.print.openDialog();

            this.$store
                .dispatch("fetchWorkOrder", {
                    url: `receiving/print_4x6_label`,
                    method: "get",
                    body: {
                        receiving_id: id,
                    },
                })
                .then((data) => {
                    if (typeof data != "undefined" && data.receiving) {
                        this.file_name = data.receiving.file_name;
                        this.$store.commit("mutateWorkOrder", {
                            property: "receiving",
                            method: "patch",
                            id: id,
                            pk: "receiving_id",
                            with: {
                                printed: "1",
                            },
                        });
                    } else {
                        this.file_name = "";
                        this.$refs.print.close();
                        this.createAlert();
                    }
                });
        },
        showPrinters() {
            // this.startLoader();
            this.$refs.print.openDialog();

            this.$store
                .dispatch("fetchWorkOrder", {
                    url: `receiving/print_4x6_label`,
                    method: "get",
                    body: {
                        receiving_id: this.selected_receiving.map((r) => r.receiving_id),
                    },
                })
                .then((data) => {
                    if (typeof data != "undefined" && data.receiving) {
                        this.file_name = data.receiving.file_name;
                        this.selected_receiving.forEach((r) => {
                            this.$store.commit("mutateWorkOrder", {
                                property: "receiving",
                                method: "patch",
                                id: r.receiving_id,
                                pk: "receiving_id",
                                with: {
                                    printed: "1",
                                },
                            });
                        });
                    } else {
                        this.file_name = "";
                        this.$refs.print.close();
                        this.createAlert();
                    }
                });
        },
        findPartFromScan(part) {
            let found_part = part.part_number ? this.parts.filter((p) => p.customer_part_number == part.part_number) : null;
            if (found_part && found_part.length > 1) {
                // if multiple parts have same part_number show the options
                this.barcode_options = found_part;
                this.show_barcode_options = true;

                this.receive.received_qty = part.qty;
                this.receive.lot_number = part.lot_number;
                this.receive.po_number = part.po_number;
                this.receive.date_received = this.current_day;
                this.$store.commit("toggleGlobalSnackbar", false);
            } else if (found_part && found_part.length > 0 && found_part[0] && found_part[0].part_id) {
                this.receive.part_id = found_part[0].part_id;

                this.receive.received_qty = part.qty;
                this.receive.lot_number = part.lot_number;
                this.receive.po_number = part.po_number;
                this.receive.date_received = this.current_day;

                this.getPartInfo(found_part[0].part_id, true);
                this.$refs.scan_barcode.closeBarcode();
                this.receiving_dialog = true;
                this.from_scan = true;
            } else {
                this.$refs.scan_barcode.resetBarcode(true);
                this.$store.commit("toggleGlobalSnackbar", false);
            }
        },
        parseBarcode(barcode_value) {
            let value = null;
            try {
                value = JSON.parse(barcode_value);
            } catch (e) {}

            if (value) {
                this.current_obj = null;
                if (typeof value == "object") {
                    this.findPartFromScan(value);
                } else {
                    this.submitBarcode(value);
                }
            } else {
                this.$refs.scan_barcode.setLoader(false);
                this.createAlert("error", "scan_again");
            }
        },
        getWarehouse(status = true) {
            if (status) {
                this.$store.commit("toggleModalLoader", true);
                this.warehouse_dialog = true;
            }
            this.$store
                .dispatch("fetchWorkOrder", {
                    url: "warehouse?line_id=2",
                    method: "get",
                    stateProperty: "warehouse",
                    commit: true,
                })
                .then((data) => {
                    this.$store.commit("toggleModalLoader", false);
                });
        },
        closeWarehouseDialog() {
            this.warehouse_dialog = false;
            this.$store.commit("toggleModalLoader", false);
        },
        goToPart(part) {
            this.$store.commit("toggleModalLoader", true);
            this.$router.push({ name: "part_profile", params: { id: part.part_id } });
        },
        setView(view) {
            if (view != this.current_view) {
                this.$router.push({ name: "receiving", params: { view: view != "receiving" ? view : null, loader: false }, query: this.$route.query });
            }
        },
    },
};
</script>
